import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import MainComp from './Pages/Main/Main';
import LoginComp from './Pages/auth/Login';
import ProfileComp from './Pages/profile/profile';
import FavoriteComp from './Pages/favorite/favorite';
import { useEffect, useState } from 'react';
import CharidyComp from './Pages/charidy/charidy';
import BOMainComp from './Pages/BO/Main/BOMain';


function App() {
  
  const [dayOffset, setDayOffset] = useState(0);
  const isAuthenticated = !!localStorage.getItem("auth-token"); // true if token exists

  useEffect(()=>{
    // console.log(dayOffset)

    localStorage.setItem('dayOffset', dayOffset);

  }, [dayOffset])

  return (
    <Router>
      <Routes>
        {!isAuthenticated ? (
          <>
            <Route path="/" element={<LoginComp />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        ) : (
          <>
            <Route
              path="/main"
              element={
                <MainComp
                  key={dayOffset}
                  date={(() => {
                    const d = new Date();
                    d.setDate(d.getDate() + dayOffset);
                    return d;
                  })()}
                  do={dayOffset}
                  sdo={(num) => setDayOffset(dayOffset + num)}
                />
              }
            />
        
            <Route path="/profile" element={<ProfileComp />} />
            <Route path="/charidy" element={<CharidyComp />} />
            <Route path="/favorite" element={<FavoriteComp />} />
            <Route path="/bo" element={<BOMainComp />} />
            <Route path="*" element={<Navigate to="/main" date={new Date() }/>} />

            
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
